"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigningArchwayNomosClient = void 0;
const cosmwasm_stargate_1 = require("@cosmjs/cosmwasm-stargate");
const amino_1 = require("@cosmjs/amino");
const proto_signing_1 = require("@cosmjs/proto-signing");
const stargate_1 = require("@cosmjs/stargate");
const tendermint_rpc_1 = require("@cosmjs/tendermint-rpc");
const long_1 = __importDefault(require("long"));
const arch3_js_1 = require("@archwayhq/arch3.js");
const lodash_1 = __importDefault(require("lodash"));
const signingNomosClient_1 = require("../signingNomosClient");
const archwayNomosClient_1 = require("./archwayNomosClient");
const defaultGasAdjustment = 1.3;
function buildResult(response) {
    const { height, transactionHash, gasWanted, gasUsed, events, parsedLogs } = response;
    return {
        logs: parsedLogs,
        height,
        transactionHash,
        events,
        gasWanted,
        gasUsed,
    };
}
const flatFeeRequiredTypes = [
    '/cosmwasm.wasm.v1.MsgExecuteContract',
    '/cosmwasm.wasm.v1.MsgMigrateContract',
];
class SigningArchwayNomosClient extends signingNomosClient_1.SigningNomosClient {
    constructor(tmClient, signer, options) {
        const { registry = new proto_signing_1.Registry([...stargate_1.defaultRegistryTypes, ...cosmwasm_stargate_1.wasmTypes, ...arch3_js_1.rewardsTypes]), aminoTypes = new stargate_1.AminoTypes(Object.assign(Object.assign(Object.assign({}, (0, stargate_1.createDefaultAminoConverters)()), (0, cosmwasm_stargate_1.createWasmAminoConverters)()), (0, arch3_js_1.createRewardsAminoConverters)())), gasAdjustment = defaultGasAdjustment, } = options;
        super(tmClient, signer, Object.assign(Object.assign({}, options), { registry, aminoTypes }));
        this.archwayQueryClient = archwayNomosClient_1.NomosArchwayClient.createSync(tmClient);
        this.gasAdjustment = gasAdjustment;
    }
    static connectWithSigner(endpoint, signer, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const tmClient = yield tendermint_rpc_1.Tendermint34Client.connect(endpoint);
            return SigningArchwayNomosClient.createWithSigner(tmClient, signer, options);
        });
    }
    static connectWithSignerAndBatchClient(endpoint, signer, options, batchClientOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const rpcClient = new tendermint_rpc_1.HttpBatchClient(endpoint, batchClientOptions);
            const tmClient = yield tendermint_rpc_1.Tendermint34Client.create(rpcClient);
            return SigningArchwayNomosClient.createWithSigner(tmClient, signer, options);
        });
    }
    static createWithSigner(tmClient, signer, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return new SigningArchwayNomosClient(tmClient, signer, options);
        });
    }
    static offline(_a, _b = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('Nomos: not implemented');
        });
    }
    setContractMetadata(senderAddress, metadata, fee, memo) {
        var _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const message = arch3_js_1.RewardsMsgEncoder.setContractMetadata({
                senderAddress,
                metadata: {
                    contractAddress: metadata.contractAddress,
                    ownerAddress: (_c = metadata.ownerAddress) !== null && _c !== void 0 ? _c : '',
                    rewardsAddress: (_d = metadata.rewardsAddress) !== null && _d !== void 0 ? _d : '',
                },
            });
            const response = yield this.assertSignAndBroadcast(senderAddress, [message], fee, memo);
            const metadataAttr = stargate_1.logs.findAttribute(response.parsedLogs, 'archway.rewards.v1.ContractMetadataSetEvent', 'metadata');
            const contractMetadata = JSON.parse(metadataAttr.value);
            return Object.assign(Object.assign({}, buildResult(response)), { metadata: {
                    contractAddress: contractMetadata.contract_address,
                    ownerAddress: contractMetadata.owner_address,
                    rewardsAddress: contractMetadata.rewards_address,
                } });
        });
    }
    setContractPremium(senderAddress, contractAddress, flatFee, fee, memo) {
        return __awaiter(this, void 0, void 0, function* () {
            const message = arch3_js_1.RewardsMsgEncoder.setFlatFee({
                senderAddress,
                contractAddress,
                flatFeeAmount: flatFee,
            });
            const response = yield this.assertSignAndBroadcast(senderAddress, [message], fee, memo);
            const flatFeeAttr = stargate_1.logs.findAttribute(response.parsedLogs, 'archway.rewards.v1.ContractFlatFeeSetEvent', 'flat_fee');
            return Object.assign(Object.assign({}, buildResult(response)), { premium: {
                    contractAddress,
                    flatFee: JSON.parse(flatFeeAttr.value),
                } });
        });
    }
    withdrawContractRewards(senderAddress, limit, fee, memo) {
        var _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const rewardsAddress = senderAddress;
            const message = arch3_js_1.RewardsMsgEncoder.withdrawRewards({
                rewardsAddress,
                recordsLimit: {
                    limit: long_1.default.fromNumber(limit),
                },
            });
            const response = yield this.signAndBroadcast(senderAddress, [message], fee, memo);
            const parsedLogs = stargate_1.logs.parseRawLog(response.rawLog);
            const firstLogs = parsedLogs.find(() => true);
            const rewardsAttr = (_d = (_c = firstLogs === null || firstLogs === void 0 ? void 0 : firstLogs.events.find((event) => event.type === 'archway.rewards.v1.RewardsWithdrawEvent')) === null || _c === void 0 ? void 0 : _c.attributes.find((attr) => attr.key === 'rewards')) === null || _d === void 0 ? void 0 : _d.value;
            const rewards = rewardsAttr ? JSON.parse(rewardsAttr) : [];
            return Object.assign(Object.assign({}, buildResult(Object.assign(Object.assign({}, response), { parsedLogs }))), { rewardsAddress,
                rewards });
        });
    }
    calculateFee(signerAddress, messages, memo, gasAdjustment = this.gasAdjustment, granter, payer) {
        return __awaiter(this, void 0, void 0, function* () {
            const gasEstimation = yield this.simulate(signerAddress, messages, memo);
            const gas = Math.round(gasEstimation * gasAdjustment);
            const { estimatedFee } = yield this.getEstimateTxFees(gas);
            const fee = yield this.includeFlatFees(messages, estimatedFee);
            return Object.assign(Object.assign({}, fee), { granter,
                payer });
        });
    }
    includeFlatFees(messages, fee) {
        return __awaiter(this, void 0, void 0, function* () {
            const _getContractPremium = lodash_1.default.memoize((contractAddress) => this.getContractPremium(contractAddress));
            const flatFees = yield Promise.all(messages
                .filter(({ typeUrl }) => flatFeeRequiredTypes.includes(typeUrl))
                .map(({ value }) => __awaiter(this, void 0, void 0, function* () {
                const contractAddress = lodash_1.default.get(value, 'contract');
                const { flatFee } = yield _getContractPremium(contractAddress);
                return flatFee;
            }))).then(lodash_1.default.compact);
            const amount = [...fee.amount, ...flatFees].reduce(amino_1.addCoins);
            return Object.assign(Object.assign({}, fee), { amount: [amount] });
        });
    }
    assertSignAndBroadcast(signerAddress, messages, fee, memo) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.signAndBroadcast(signerAddress, messages, fee, memo);
            (0, stargate_1.assertIsDeliverTxSuccess)(response);
            const parsedLogs = stargate_1.logs.parseRawLog(response.rawLog);
            return Object.assign(Object.assign({}, response), { parsedLogs });
        });
    }
    withdrawRewards(delegatorAddress, validatorAddress, fee, memo) {
        const _super = Object.create(null, {
            withdrawRewards: { get: () => super.withdrawRewards }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return yield _super.withdrawRewards.call(this, delegatorAddress, validatorAddress, fee, memo);
        });
    }
    getBlockRewardsTracking() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.archwayQueryClient.getBlockRewardsTracking();
        });
    }
    getContractMetadata(contractAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.archwayQueryClient.getContractMetadata(contractAddress);
        });
    }
    getContractPremium(contractAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.archwayQueryClient.getContractPremium(contractAddress);
        });
    }
    getEstimateTxFees(gasLimit, contractAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.archwayQueryClient.getEstimateTxFees(gasLimit, contractAddress);
        });
    }
    getOutstandingRewards(rewardsAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.archwayQueryClient.getOutstandingRewards(rewardsAddress);
        });
    }
    getRewardsPool() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.archwayQueryClient.getRewardsPool();
        });
    }
    getAllRewardsRecords(rewardsAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.archwayQueryClient.getAllRewardsRecords(rewardsAddress);
        });
    }
}
exports.SigningArchwayNomosClient = SigningArchwayNomosClient;
//# sourceMappingURL=signingArchwayNomosClient.js.map